import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { AzureAD } from 'react-aad-msal';
import App from './App';
import { authProvider } from './auth/authProvider';
import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <AzureAD provider={authProvider} forceLogin>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </AzureAD>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//A1_CTRL_F5_Issue_After_New_Deploy
registerServiceWorker({
    onUpdate: (registration) => {
        var refreshing;
        navigator.serviceWorker.addEventListener('controllerchange',
            function() {
              if (refreshing) return;
              refreshing = true;
              window.location.reload();
              window.location.href="/";
             
            }
        );
        function promptUserToRefresh(reg) {
            alert("There is a new version of the application available. Please click OK to navigate to home page of Insight.")
            reg.waiting.postMessage({type: "SKIP_WAITING"});
        }
        listenForWaitingServiceWorker(registration, promptUserToRefresh);
      
        function listenForWaitingServiceWorker(reg, callback) {
          function awaitStateChange() {
            reg.installing.addEventListener('statechange', function() {
              if (this.state === 'installed') callback(reg);
            });
          }
          if (!reg) return;
          if (reg.waiting) return callback(reg);
          if (reg.installing) awaitStateChange();
          reg.addEventListener('updatefound', awaitStateChange);
        }
    },
  });
  //End
